import apiClient from './axios/toolsClient';

export async function getToolsReportDataApi(step: string, type: string) {
  return apiClient
    .get(`/reports/production/${step}/filter/${type}`)
    .then((resp) => resp.data)
    .catch(() => false);
}
